import { useEffect, useState } from "react";
import { ArrowRight, Save } from "lucide-react";
import { PageHeader } from "../components/Primitives";
import { api, errorText } from "../lib/api";

export default function Settings({ user }) {
  const [library, setLibrary] = useState(null);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current_password: "", new_password: "" });

  const load = async () => {
    if (user.role === "MAIN_ADMIN") return;
    try {
      const res = await api.get("/library/profile");
      setLibrary(res.data.data);
    } catch (err) {
      setError(errorText(err));
    }
  };

  useEffect(() => {
    load();
  }, [user.role]);

  const saveLibrary = async (event) => {
    event.preventDefault();
    try {
      const payload = { ...library };
      delete payload.id;
      delete payload.created_at;
      delete payload.updated_at;
      delete payload.students;
      delete payload.seats;
      delete payload.occupied_seats;
      delete payload.available_seats;
      await api.patch("/library/profile", payload);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError(errorText(err));
    }
  };

  const changePassword = async (event) => {
    event.preventDefault();
    try {
      await api.post("/auth/change-password", passwordForm);
      setPasswordForm({ current_password: "", new_password: "" });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError(errorText(err));
    }
  };

  return (
    <div className="page-enter">
      <PageHeader eyebrow="PREFERENCES" title="Settings" description="Keep profile, branding and security tuned to your library." />
      {error ? <div className="error-message">{error}</div> : null}
      {saved ? <div className="success-message">Saved successfully.</div> : null}

      {user.role !== "MAIN_ADMIN" && library ? (
        <section className="content-card">
          <div className="card-heading"><div><span className="card-kicker">LIBRARY PROFILE</span><h2>{library.name}</h2></div></div>
          <form className="modal-form grid-form" onSubmit={saveLibrary} data-testid="library-profile-form" style={{ marginTop: 24 }}>
            <label>Library name<input value={library.name || ""} onChange={(event) => setLibrary({ ...library, name: event.target.value })} /></label>
            <label>Owner name<input value={library.owner_name || ""} onChange={(event) => setLibrary({ ...library, owner_name: event.target.value })} /></label>
            <label>Mobile<input value={library.mobile || ""} onChange={(event) => setLibrary({ ...library, mobile: event.target.value })} /></label>
            <label>Email<input type="email" value={library.email || ""} onChange={(event) => setLibrary({ ...library, email: event.target.value })} /></label>
            <label>Address<input value={library.address || ""} onChange={(event) => setLibrary({ ...library, address: event.target.value })} /></label>
            <label>City<input value={library.city || ""} onChange={(event) => setLibrary({ ...library, city: event.target.value })} /></label>
            <label>Opening time<input type="time" value={library.opening_time || "06:00"} onChange={(event) => setLibrary({ ...library, opening_time: event.target.value })} /></label>
            <label>Closing time<input type="time" value={library.closing_time || "22:00"} onChange={(event) => setLibrary({ ...library, closing_time: event.target.value })} /></label>
            <label className="grid-span-2">Footer / receipt text<input value={library.footer_text || ""} onChange={(event) => setLibrary({ ...library, footer_text: event.target.value })} /></label>
            <div className="modal-actions grid-span-2">
              <button className="button button-primary" type="submit" data-testid="save-library-profile"><Save size={16} /> Save profile</button>
            </div>
          </form>
        </section>
      ) : null}

      <section className="content-card" style={{ marginTop: 16 }}>
        <div className="card-heading"><div><span className="card-kicker">SECURITY</span><h2>Change password</h2></div></div>
        <form className="modal-form" onSubmit={changePassword} style={{ marginTop: 24 }}>
          <label>Current password<input type="password" required value={passwordForm.current_password} onChange={(event) => setPasswordForm({ ...passwordForm, current_password: event.target.value })} data-testid="current-password-input" /></label>
          <label>New password<input type="password" required minLength={8} value={passwordForm.new_password} onChange={(event) => setPasswordForm({ ...passwordForm, new_password: event.target.value })} data-testid="new-password-input" /></label>
          <div className="modal-actions">
            <button className="button button-primary" type="submit" data-testid="change-password-button">Change password <ArrowRight size={16} /></button>
          </div>
        </form>
      </section>
    </div>
  );
}
